import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class ContactAPI {

  static ModelNo = 2;

  static list = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    const sorting = list.sorting;
    const body = { filter, page, perPage, sorting };
    
    fetch(Config.app.link + 'api/contact/list', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getInnerList = (modelType, modelId, success, failure) => {
    const filter = [{field: 'model', type: 'model', 'condition': 'equals',
      value: `${modelType}~${modelId}`}];
    const page = 1;
    const perPage = 10;
    const body = { filter: filter, page: page, perPage: perPage };
    fetch(Config.app.link + 'api/contact/list', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getPropertyContactList = (property, success, failure) => {
    fetch(Config.app.link + `api/property/contact/${property}`, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getProjectContactList = (project, success, failure) => {
    fetch(Config.app.link + `api/project/contact/${project}`, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/contact/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (contact, success, failure) => {
    fetch(Config.app.link + 'api/contact/add-edit', new Header('POST', contact))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static addLeadContact = (lead, contact, success, failure) => {
    fetch(Config.app.link + 'api/contact/lead', new Header('POST', { lead, contact }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

static addProjectContact = (data, success, failure) => {
  fetch(Config.app.link + 'api/contact/project', new Header('POST', data))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
};

  static removeLead = (id, success, failure) => {
    fetch(Config.app.link + 'api/contact/lead/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/contact/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static deletePropertyContact = (id, success, failure) => {
    fetch(Config.app.link + 'api/contact/delete_property_contact/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static deleteProjectContact = (id, success, failure) => {
    fetch(Config.app.link + 'api/contact/delete_project_contact/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static quickSaveContact = (contact, success, failure) => {
    fetch(Config.app.link + 'api/contact/quickadd-edit', new Header('POST', contact))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default ContactAPI;